const shippingCountriesObject = {
  SG: { value: "SG", label: "Singapore" },
  MY: { value: "MY", label: "Malaysia" },
  PH: { value: "PH", label: "Philippines" },
  AU: { value: "AU", label: "Australia" },
  KR: { value: "KR", label: "South Korea" },
  US: { value: "US", label: "United States" },
  ID: { value: "ID", label: "Indonesia" },
  TH: { value: "TH", label: "Thailand" },
  VN: { value: "VN", label: "Vietnam" },
};

const noStoreCountriesObject = {
  PH: { value: "PH", label: "Philippines" },
  AU: { value: "AU", label: "Australia" },
  KR: { value: "KR", label: "South Korea" },
  US: { value: "US", label: "United States" },
  ID: { value: "ID", label: "Indonesia" },
  TH: { value: "TH", label: "Thailand" },
  VN: { value: "VN", label: "Vietnam" },
};

const noStoreData = {
  title: "COMING SOON TO A STORE NEAR YOU!",
  subHeading:
    "We're working on bringing Modern Molecules to a store near you soon. Register your interest bellow and you'll be the first to know when we are live.",
};

const noShippingData = {
  title: "We Haven’t Launched in Your Country Yet!",
  subHeading:
    "Unfortunately Modern Molecules isn't available in your country right now. We're working on it, so sign up to the waitlist below and you'll be the first to know when its live.",
};
